import { getComponentCanvasVertices } from './markupGeometry.js';

/** Canvas anchor for ortho when dragging vertex i (adjacent fixed vertex). */
export function orthoAnchorForVertex(component, vertexIndex, viewport) {
  const verts = getComponentCanvasVertices(component, viewport);
  if (!verts.length) return null;
  if (vertexIndex > 0) return verts[vertexIndex - 1];
  if (vertexIndex < verts.length - 1) return verts[vertexIndex + 1];
  return null;
}
